export class Ability {
    constructor(
        public name: string = '',
        public modifierName: string = '',
    ) { }
}
